import '../../../Osc.Common/Frontend/styles/main.scss';
import '../../../Osc.Common/Frontend/auth';
import '../styles/trumps.scss';

window.addEventListener("hashchange", handleHash);
handleHash();

function handleHash() {
    var urlHash = window.location.hash;
    var storedHash = sessionStorage.getItem("returnUrlHash");

    if (urlHash && (urlHash !== storedHash)) {
        sessionStorage.setItem("returnUrlHash", urlHash);
    } else if (!urlHash && storedHash) {
        window.location.hash = storedHash;
    }
}